let pages = 0;
const postRange = [];
let currentUrl = '';

window.onload = function () {
    if (document.body.classList.contains('post-template')) {
        initInfinitePost();
    }
};

function debounce(callback, wait) {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

function initInfinitePost() {
    const posts = document.querySelectorAll('article.gh-post')
    const lastPost = posts[posts.length - 1];

    const heightPost = lastPost.getBoundingClientRect().height;
    // const toTopPost = lastPost.getBoundingClientRect().top;

    const toTopPost = lastPost.offsetTop;

    postRange.push({
        from: 0,
        to: heightPost + toTopPost,
        height: heightPost,
        toTop: lastPost.getBoundingClientRect().top,
        url: lastPost.getAttribute('data-c'),
        title: lastPost.getElementsByClassName('gh-header-title')[0].innerText
    })

    window.addEventListener('scroll', (e) => {
        debounce(recalculatePosition(), 300)

        syncPageUrl();
    });
}

function getClosestElementByScrollTop(elements) {
    let closestElement = null;

    let minDistance = Infinity;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    elements.forEach(element => {
        const elementTop = element.offsetTop;
        const distance = Math.abs(elementTop - scrollTop);

        if (distance < minDistance) {
            minDistance = distance;
            closestElement = element;
        }
    });

    return closestElement;
}

function recalculatePosition() {
    const postsList = document.getElementsByClassName('gh-post');
    const pageScrollPosition = window.scrollY;
    const pageInnerHeight = window.innerHeight;
    const pageLastPost = postsList[postsList.length - 1];

    const nextPageLoad = pageLastPost.getAttribute('data-p');
    if (!nextPageLoad) {
        return;
    }

    const pageLastPostInitScroll = pageLastPost.offsetHeight;
    const loadNextPost = pageInnerHeight + pageScrollPosition + 400 >= pageLastPostInitScroll + pageLastPost.offsetTop;
    const isProcessing = pageLastPost.classList.contains('processing');

    if (loadNextPost && !isProcessing) {
        debounce(loadData(nextPageLoad), 800)

        pageLastPost.classList.add('processing');
    }

    return null;
}

function syncPageUrl() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    const el = postRange.find(el => {
        return scrollTop >= el.from && scrollTop <= el.to
    });

    if (el && currentUrl !== el.url) {
        document.title = el.title;

        history.pushState({ page: el.url }, el.title, el.url);

        currentUrl = el.url;
    }
    // window.history.pushState('page2', 'Title', currentPostUrl);

    return null;
}

async function loadData(url) {
    const feedElement = document.querySelector('.content-post');

    const res = await fetch(url);
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const postElement = doc.querySelector('.content-post > *');
    const clonedItem = document.importNode(postElement, true);

    feedElement.appendChild(clonedItem);

    const posts = feedElement.querySelectorAll('article.gh-post')
    const lastPost = posts[posts.length - 1];
    const toTopPost = lastPost.getBoundingClientRect().top + window.scrollY;
    setTimeout(() => {
        const heightPost = lastPost.getBoundingClientRect().height;

        postRange.push({
            from: toTopPost,
            to: heightPost + toTopPost,
            height: heightPost,
            lastPost: lastPost,
            toTop: lastPost.getBoundingClientRect().top,
            url: lastPost.getAttribute('data-c'),
            title: lastPost.getElementsByClassName('gh-header-title')[0].innerText
        })


        /* Add lightbox to gallery images */
        lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');

        const sources = ['.gh-content iframe[src*="youtube.com"]', '.gh-content iframe[src*="youtube-nocookie.com"]', '.gh-content iframe[src*="player.vimeo.com"]', '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]', '.gh-content object', '.gh-content embed'];
        // eslint-disable-next-line no-undef
        reframe(document.querySelectorAll(sources.join(',')));

    }, 400);

    pages++;

    return 'test';
}
